var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,15.318 L27,11.682 C25.142625,11.021625 23.96925,10.836 23.378625,9.410625 L23.378625,9.4095 C22.78575,7.979625 23.491125,7.00875 24.3315,5.239125 L21.760875,2.6685 C20.00475,3.50325 19.02375,4.215375 17.5905,3.621375 L17.589375,3.621375 C16.16175,3.029625 15.975,1.848375 15.318,0 L11.682,0 C11.02725,1.839375 10.839375,3.0285 9.410625,3.621375 L9.4095,3.621375 C7.979625,4.215375 7.011,3.511125 5.239125,2.6685 L2.6685,5.239125 C3.506625,7.003125 4.215375,7.977375 3.621375,9.4095 C3.0285,10.839375 1.839375,11.02725 0,11.682 L0,15.318 C1.836,15.9705 3.0285,16.160625 3.621375,17.589375 C4.217625,19.031625 3.493125,20.026125 2.6685,21.75975 L5.239125,24.3315 C6.996375,23.495625 7.977375,22.784625 9.4095,23.378625 L9.410625,23.378625 C10.839375,23.970375 11.026125,25.155 11.682,27 L15.318,27 C15.97275,25.1595 16.16175,23.97375 17.598375,23.37525 L17.5995,23.37525 C19.01925,22.78575 19.9845,23.488875 21.75975,24.332625 L24.330375,21.760875 C23.493375,20.0025 22.7835,19.02375 23.376375,17.591625 C23.96925,16.16175 25.162875,15.971625 27,15.318 L27,15.318 Z M13.5,18 C11.014875,18 9,15.985125 9,13.5 C9,11.014875 11.014875,9 13.5,9 C15.985125,9 18,11.014875 18,13.5 C18,15.985125 15.985125,18 13.5,18 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/Gear.76108cef.svg";
export { ForwardRef as ReactComponent };